module.exports = __webpack_public_path__ + "static/media/6.6d78ef7a.jpg";